import React, {useEffect, useRef, useState} from 'react';
import styles from './volume-control.module.scss';

type Props = {
    player: HTMLAudioElement | undefined,
};

const VolumeControl: React.FC<Props> = ({ player }) => {
    const [volume, setVolume] = useState<number>(100);
    const [measureMoves, setMeasureMoves] = useState<boolean>(false);
    const [muted, setMuted] = useState<boolean>(false);
    const barRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if(player) {
            const volumeChange = (e: any) => {
                setVolume(player.volume * 100);
            };
            player.addEventListener('volumechange', volumeChange);
            player.volume = volume / 100;
            return () => window.removeEventListener('volumechange', volumeChange);
        }
    }, [player]);


    useEffect(() => {
        const changeIfMeasuring = (e: MouseEvent) => {
            if(measureMoves && player) {
                const currentPosition = e.pageX;
                const pd = barRef.current as HTMLDivElement;
                const maxPosition = pd.offsetWidth + pd.offsetLeft;
                const minPosition = pd.offsetLeft;
                if(currentPosition >= maxPosition)
                    player.volume = 1;
                else {
                    if(currentPosition <= minPosition)
                        player.volume = 0;
                    else {
                        player.volume = (currentPosition - pd.offsetLeft) / pd.offsetWidth;
                    }
                }
            }
        };

        const disableMeasuring = (e: any) => {
            changeIfMeasuring(e);
            setMeasureMoves(false);
            const body = document.body;
            body.removeAttribute('style');
        };

        window.addEventListener('mousedown', changeIfMeasuring);
        window.addEventListener('mousemove', changeIfMeasuring);
        window.addEventListener('mouseup', disableMeasuring);
        return () => {
            window.removeEventListener('mousedown', changeIfMeasuring);
            window.removeEventListener('mousemove', changeIfMeasuring);
            window.removeEventListener('mouseup', disableMeasuring);
        }
    });

    const mouseDown = (e: any) => {
        setMeasureMoves(true);
        if(muted && player) {
            player.muted = false;
            setMuted(false);
        }
        const body = document.body;
        body.style.userSelect = 'none';
        body.style.cursor = 'pointer';
    };

    const changeMute = () => {
        if(player) {
            player.muted = !player.muted;
            setMuted(player.muted);
        }
    }

    return (
        <div className={styles.volumeControl}>
            <div className={styles.volumeIcon} onClick={changeMute}>
                {muted || !volume ? (
                    <i className="fa fa-volume-mute" />
                ) : volume > 50 ? (
                    <i className="fa fa-volume-up" />
                ) : (
                    <i className="fa fa-volume-down" />
                )}
            </div>
            <div className={styles.volumeBar + (muted ? ' ' + styles.muted : '')} ref={barRef} onMouseDown={mouseDown}>
                <div className={styles.volumeSize} style={{ width: volume + '%' }} />
            </div>
        </div>
    );
}

export default VolumeControl;
